export const SKILLS=[
    {
        title: "Frontend",
        icon: "bi bi-laptop",
        skills:[
            {
                skill:"HTML5",percentage: "80%"
            },
            {skill:"CSS(Boostrap)",percentage:"70%"},
            {skill:"JavaScript(JQuery)",percentage:"55%"},
            {skill:"React.JS",percentage:"60%"},
            
        ]
    },
    {
        title:"Backend",
        icon:"bi bi-laptop",
        skills:[
            {skill:"PHP|Laravel",percentage:"60%"},
            {skill:"MySQL",percentage:"70%"},
            {skill:"Node.js",percentage:"50%"},
            {skill:"Python",percentage:"30%"},
            
            
        ]
    },
    {
        title:"Tools",
        icon:"bi bi-tools",
        skills:[
            {skill:"Git & GitHub",percentage:"50%"},
            {skill:"Visual Studio Code",percentage:"70%"},
            {skill:"Figma",percentage:"40%"},
            {skill:"Microsoft Office(Word,Excel,PowerPoint)"
        , percentage:"50%"},
             {skill:"Capcut,Adobe Photoshop",percentage:"40%"}
        ]
    },{
        title:"Soft Skills",
        icon: "bi bi-card-heading",
        skills:[
            {skill:"Teamwork",percentage:"70%"},
            {skill:"Problem-solving",percentage:"70%"},
            {skill:"Communication",percentage:"70%"},
            {skill:"Time Management(Scrum Agile)",percentage:"60%"},
        ]
    }
]